export default __webpack_public_path__ + "static/end_of_time-99134bfe40e70d0c8bcda3d68f32784b.mp3";